module.exports = "<a class=\"{{logoClass}}\" routerLink=\"/\">\n\t<img src=\"assets/images/logo.png\" alt=\"logo\">\n</a>\n"